import { NavLink } from 'react-router-dom'
import { Menu } from '@mantine/core'

import type { DropdownMenuProps } from '@/components/DropdownMenu/DropdownMenu.types'
import { Text } from '@/components/Text/Text'

import classes from './DropdownMenu.module.css'

export function DropdownMenu({
  button,
  items,
  position = 'bottom',
  w = 150,
  ...props
}: DropdownMenuProps) {
  return (
    <Menu position={position} radius={12} width={w} {...props}>
      <Menu.Target>{button}</Menu.Target>

      <Menu.Dropdown className={classes.menuDropdown}>
        {items.map(item => (
          <Menu.Item
            key={item.label}
            className={classes.menuItem}
            component={NavLink}
            leftSection={<item.icon height={24} />}
            onClick={item.to ? undefined : item.onClick}
            to={item.to || ''}
          >
            <Text>{item.label}</Text>
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}
